import { Component, OnInit, OnDestroy } from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {Store} from "@ngrx/store";
import * as GdprNoticeActions from '../../state/gdprNotice/gdprNotice.actions';
import * as GdprNoticeSelectors from '../../state/gdprNotice/gdprNotice.selectors';
import {PopupService} from "../../services/popup.service";
import {NgClass, NgIf} from "@angular/common";
import {first, Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-gdpr-notice',
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    NgIf
  ],
  templateUrl: './gdpr-notice.component.html',
  styleUrl: './gdpr-notice.component.scss'
})
export class GdprNoticeComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  token: string = null
  canOptOut: boolean = false
  isOptOutPressed: boolean = false
  isOptOutSuccess: boolean = false

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store,
    private popupService: PopupService
  ) { }

  ngOnInit() {
    // Set the background color of the <body> tag to white
    document.body.style.backgroundColor = 'white';

    if (!this.isOptOutPressed) {

      this.checkForToken();

      this.store.select(GdprNoticeSelectors.selectValidationSuccess)
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          if (data) {
            console.log('Validation success message:', data.message);
            // this.popupService.notify(data.message, 'Validation Success', 'success');
            this.canOptOut = true;
          }
        });

      this.store.select(GdprNoticeSelectors.selectValidationError)
        .pipe(takeUntil(this.destroy$))
        .subscribe(error => {
          if (error) {
            console.error('Validation error:', error);
            // this.popupService.notify(error, 'Validation Error', 'error');
            this.router.navigate(['/404']);
          }
        });

    }

  }

  ngOnDestroy() {
    // Revert the background color of the <body> tag to black
    document.body.style.backgroundColor = '#0f174b';

    this.destroy$.next();
    this.destroy$.complete();
  }

  checkForToken(): void {

    this.activatedRoute.queryParams.subscribe(queryParams => {
      const token = queryParams['token'];
      this.token = token;
      this.store.dispatch(GdprNoticeActions.checkToken({ token }));
    });
  }

  onOptOut(): void {
    this.isOptOutPressed = true

    const token = this.token
    this.store.dispatch(GdprNoticeActions.optOut({ token }));

    this.store.select(GdprNoticeSelectors.selectOptOutSuccess).subscribe(response => {
      if (response) {
        console.log('Opt-out success message:', response.message);
        this.popupService.notify(response.message, 'Opt-Out Success', 'success');
        this.isOptOutSuccess = true
      }
    });

    this.store.select(GdprNoticeSelectors.selectOptOutError).subscribe(error => {
      if (error) {
        console.error('Opt-out error:', error);
        this.popupService.notify(error.error.message, 'Opt-Out Error', 'error');
        this.router.navigate(['/']);
      }
    });
  }

}
